import React, { Component } from 'react';
import { connect } from 'react-redux';
import Slider from "react-slick";
import Parser from "html-react-parser";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {API_URL} from "../../config/apiEndpoints";
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';

class CustomSlide extends Component {

 

    render() {  
        const {index, description, imgSrc, title, subtitle, goTo, ...props} = this.props;
        if (imgSrc) {        
            if (title && description) {
                return (
                    <div key={index} {...props} className="slider-wrp">
                        <div className="slider-description">
                            <div className="slider-description-content">
                                <div className="slider-description-content-limit">
                                    <h1>{title}</h1>
                                    <h2 className="d-none d-sm-none d-md-none d-lg-block">{subtitle}</h2>
                                    <h5 className="d-none d-sm-none d-md-none d-lg-block">{Parser(description.substr(0, 400))}</h5>
                                </div>
                            </div>
                        </div>
                        <div className="hitbox" onClick={() => goTo()}></div>
                        <img className="img-element" src={API_URL + imgSrc} alt={'Cinemap'}/>                    
                    </div>
                );
            } else {
                return (
                    <div key={index} {...props} className="slider-wrp">
                        <div className="hitbox" onClick={() => goTo()}></div>    
                        <img className="img-element" src={API_URL + imgSrc} alt={'Cinemap'} />          
                    </div>
                );
            }
        } else {
            return "";
        }
    }
}

class CinemapSlider extends Component {
    goTo = (url) => {
        this.props.history.push(url);
    };

    outputSlides = () => {
        
        return this.props.slides.map((slide, i) => {
            if(slide.article_image !== '') {
                return (
                    <CustomSlide
                        key={i}
                        title={ slide.article_title === undefined ? '' : slide.article_title }
                        description={ slide.article_summary === undefined ? '' : slide.article_summary }
                        imgSrc={ slide.article_image === undefined ? '' : Parser(slide.article_image) }
                        subtitle = {slide.subtitle === undefined ? '' : slide.subtitle}
                        goTo = {() => this.goTo(slide.item_link)}
                    />
                )
            } else {
                return "";
            }
        });
    };
    render() {

        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        return (
            <div className="slider">
                <div>
                    <Slider {...settings}>
                        {this.outputSlides()}
                    </Slider>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps, {})(CinemapSlider));



// WEBPACK FOOTER //
// ./src/SHARED/components/slider/slider.component.js